import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const FechaHora = () => {
    const { proyecto, setProyecto } = useProyecto();
    const { setPromptData, promptData } = useActividadesContext();

    const handleFechaHoraChange = (event) => {
        const { value } = event.target;
        setProyecto({ ...proyecto, fechaHora: value });
        setPromptData((prevData) => ({
            ...prevData,
            fecha_hora: value
        }));
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} display="flex" flexDirection="column">
                <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                Fecha y Hora
                </Typography>
                <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>
                Selecciona fecha y hora de la acción requerida
                </FormLabel>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="datetime-local"
                    type="datetime-local"
                    value={promptData.fecha_hora || ''}
                    onChange={handleFechaHoraChange}
                    inputProps={{
                        sx: {
                            fontFamily: 'montserrat',
                            color: '#336B87',
                            borderRadius: 2
                        }
                    }}
                    sx={{
                        mt: 2,
                        mb: 2,
                        width: '25%',
                        fontFamily: 'montserrat',
                        color: '#336B87'
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default FechaHora;